import { Injectable, OnDestroy } from '@angular/core';
import { Project } from '@docma-mm-core/project/project';
import {Observable, BehaviorSubject, defer, pipe, map, filter, firstValueFrom, first} from 'rxjs';
import { MmFilterModel } from './mm-filter.model';
import { Layout } from '@docma-mm-core/layout/layout';
import { MmViewService } from '../mm-view.service';
import {flattenStructure, Structure} from '@docma-mm-core/structure/structure';
import { PersonalizationService } from '@docma-mm-core/personalization/personalization.service';
import { PersonalizationKeysEnum } from '@docma-mm-core//personalization/personalization-keys.enum';
import { MmProjectDownloadService } from '../mm-project/mm-download.service';
import { MmFilterTag } from './tag/mm-filter-tag';
import { from } from 'rxjs/internal/observable/from';
import { MmProjectLoaderService } from '../mm-project/mm-project-loader.service';
import {LoadStatusEnum} from '@docma-mm-core/model/load-state/load-state.enum';
import {find} from 'rxjs/operators';

@Injectable()
export class MmFilterService implements OnDestroy {

  private stateSubject = new BehaviorSubject<MmFilterModel>(new MmFilterModel());
  public state =  this.stateSubject.asObservable();


  constructor(private readonly mmViewService: MmViewService,
              private readonly mmDownloadService: MmProjectDownloadService,
              private readonly mmPersonalizationService: PersonalizationService,
              private readonly mmProjectLoaderService: MmProjectLoaderService) {

        this.mmViewService.currentProject$
        .subscribe(p => this.initialize(p).subscribe() );
  }

  ngOnDestroy(): void {

  }

  initialize(project: Project): Observable<MmFilterModel> {
    return defer( async () => {
      const model = new MmFilterModel();
      if (project) {
        model.project = project;
        model.layout = await this.mmPersonalizationService
        .getProjectValue(project.MyDocmaUid, PersonalizationKeysEnum.LastLayoutId);
        // if (model.layout) {
        //   model.layout = await this.mmDownloadService.downloadLayout(project, model.layout.Id).toPromise();
        // }
        model.structure = await this.mmPersonalizationService.getProjectValue(project.MyDocmaUid, PersonalizationKeysEnum.LastStructureId);
        if (!model.structure) {
          model.structure = project.Structure;
        }
        else {
          const st = await firstValueFrom(this.mmProjectLoaderService.structures.pipe(filter(f => f.loadState.status === LoadStatusEnum.Loaded), map(f => flattenStructure(f.data).find(f => f.Id === model.structure.Id))));
          model.structure.Name2 = st?.Name2;
        }
      }
      this.stateSubject.next(model);
      return model;
    });

  }

  setTags(tags: MmFilterTag[]) {
    const model = new MmFilterModel(this.stateSubject.value);
    model.tags = tags;
    this.stateSubject.next(model);
  }

  // private compareProjects(p1, p2) {
  //   const id1 = p1 && p1.Id ? p1.Id : null;
  //   const id2 = p2 && p2.Id ? p2.Id : null;

  //   return id1 === id2;
  // }

  setLayout(layout: Layout) {
      // const model = new MmFilterModel(this.stateSubject.value);
      // if (model.project  && layout &&  !isIdsEquals(model.layout, layout.Id) ) {
      //   this.mmDownloadService.downloadLayout(model.project, layout.Id)
      //   .pipe(
      //     switchMap(l => from(this.mmPersonalizationService
      //       .setProjectValue(model.project.MyDocmaUid, PersonalizationKeysEnum.LastLayoutId, {Id: layout.Id, Name: layout.Name}))
      //       .pipe(map(ps => l)))
      //   )
      //   .subscribe((l: Layout) => {
      //     model.layout = l;
      //     this.stateSubject.next(model);
      //   });

      // }

      // return layout;
  }

  setStructure(structure: Structure) {

      const model = new MmFilterModel(this.stateSubject.value);
      model.structure = structure;
      if (model.project) {
        this.mmPersonalizationService
        .setProjectValue(model.project.MyDocmaUid, PersonalizationKeysEnum.LastStructureId, {Id: structure.Id, Name1: structure.Name1, RootId: structure.RootId, Parent: {Id: structure?.Parent?.Id}});

      }
      this.stateSubject.next(model);
      return structure;

  }


  get filterState() {
    return this.stateSubject.value;
  }

}
